import { withNamespaces } from "react-i18next"
import { RiAlertLine, RiScales3Line, RiShieldCheckLine, RiTaskLine } from "react-icons/ri";
import { Badge, Card, CardBody, Col, Row } from "reactstrap";
import { COMPLIANCE_CASE_DECISION_MAP, COMPLIANCE_CASE_STATE_MAP, COMPLIANCE_STATUS_MAP } from "src/modules/data-protection/constants";

const ComplianceOverview = ({ t, complianceQuery }) => {
    if (complianceQuery.isFetching) return null;

    const {
        overallStatus,
        orchestration,
        platform
    } = complianceQuery.data?.data || {};

    const overallStatusColor = COMPLIANCE_STATUS_MAP[overallStatus]?.color;
    const caseStateColor = COMPLIANCE_CASE_STATE_MAP[orchestration.state]?.color;
    const caseDecisionColor = COMPLIANCE_CASE_DECISION_MAP[orchestration.decision]?.color

    return (
        <Row className="g-3 mb-4 mt-4">
            <Col lg={3}>
                <Card>
                    <CardBody className="text-center">
                        <RiShieldCheckLine className="text-primary" size="42" />

                        <h5 className="mt-3 mb-1">
                            {t('Overall Compliance Status')}
                        </h5>

                        <Badge
                            className={`bg-${overallStatusColor}`}
                            color={overallStatusColor}
                        >
                            {
                                t(COMPLIANCE_STATUS_MAP[
                                    overallStatus
                                ]?.label)
                            }
                        </Badge>
                    </CardBody>
                </Card>
            </Col>

            <Col lg={3}>
                <Card>
                    <CardBody className="text-center">
                        <RiScales3Line className="text-warning" size="42" />

                        <h5 className="mt-3 mb-1">
                            {t('Compliance Decision')}
                        </h5>

                        {orchestration.decision ? (
                            <Badge
                                className={`bg-${caseDecisionColor}`}
                                color={caseDecisionColor}
                            >
                                {
                                    t(COMPLIANCE_CASE_DECISION_MAP[
                                        orchestration.decision
                                    ]?.label)
                                }
                            </Badge>
                        ) : (
                            <Badge className="bg-secondary" color="secondary">
                                {t('Pending')}
                            </Badge>
                        )}
                    </CardBody>
                </Card>
            </Col>

            <Col lg={3}>
                <Card>
                    <CardBody className="text-center">
                        <RiAlertLine className="text-warning" size="42" />

                        <h5 className="mt-3 mb-1">
                            {t('Open Risks')}
                        </h5>

                        <span>
                            {platform?.openRiskRates?.length || 0}
                        </span>
                    </CardBody>
                </Card>
            </Col>

            <Col lg={3}>
                <Card>
                    <CardBody className="text-center">
                        <RiTaskLine className="text-info" size="42" />

                        <h5 className="mt-3 mb-1">
                            {t('Remediation Tasks')}
                        </h5>

                        <span>
                            {platform?.openTasks?.length || 0}
                        </span>
                    </CardBody>
                </Card>
            </Col>
        </Row>
    )
}

export default withNamespaces()(
    ComplianceOverview
);